webpackJsonp([1],{

/***/ "1blB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeRandom */
/* unused harmony export arrayFind */
/* harmony export (immutable) */ __webpack_exports__["c"] = isBrower;
/* unused harmony export getAppid */
/* unused harmony export getApiUrl */
/* unused harmony export makeUrl */
/* unused harmony export getParamsFromUrl */
/* unused harmony export safeDecode */
/* harmony export (immutable) */ __webpack_exports__["a"] = parseQueryParams;
/* unused harmony export parseQueryString */
/* unused harmony export parseCallbackUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = checkCallback;
/* harmony export (immutable) */ __webpack_exports__["e"] = buildCallbackUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSafeRedirect;
/* unused harmony export queryBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("rvz5");





/**
 * 生成指定长度随机数
 * @param length
 * @returns {string}
 */
function makeRandom(length) {
  var str = "0123456789",
      ret = "";
  for (var i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param array
 * @param fn
 * @returns {null}
 */
function arrayFind(array, fn) {
  var index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
function isBrower(name) {
  var UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}

function getAppid(callback) {
  var hostname = url("hostname", callback);
  var appid = "";
  for (var key in __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].appid) {
    if (hostname == key) {
      appid = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].appid[key];
    }
  }
  if (!appid) {
    appid = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].appid[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].appid)[0]];
  }
  return appid;
}

/**
 * 根据来源获得api_url
 * @param callback
 * @returns {string}
 */
function getApiUrl(callback) {
  var hostname = url("hostname", callback);
  var api_url = "";
  for (var key in __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url) {
    if (hostname == key) {
      api_url = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url[key];
    }
  }
  if (!api_url) {
    api_url = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].api_url)[0]];
  }
  return api_url;
}

/**
 * 生成跳转链接
 * @deprecated 跳转地址请使用 buildCallbackUrl（会重新编码 path/query/hash 并保留端口），
 * 未经 checkCallback 校验的地址不允许直接用于 location 赋值
 * @param options
 * @returns {string}
 */
function makeUrl(options) {
  var url = "";
  if (options.protocol) {
    url += options.protocol + "://";
  }
  if (options.hostname) {
    url += options.hostname;
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ":" + options.port;
  }
  if (options.path) {
    url += options.path;
  }
  if (options.query) {
    var q = "";
    for (var key in options.query) {
      if (options.query[key]) {
        q += "&" + key + "=" + encodeURIComponent(options.query[key]);
      } else {
        q += "&" + key;
      }
    }
    q = q.substr(1);
    url += "?" + q;
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
function getParamsFromUrl(from) {
  var protocol = url("protocol", from);
  var hostname = url("hostname", from);
  var port = url("port", from);
  var path = url("path", from);
  var query = url("?", from);
  var hash = url("hash", from);
  return { protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash };
}

/**
 * 安全解码：解码失败时保留原始字符串，不抛异常
 * （js-url 的 query 解析遇到非法百分号编码会抛 URIError，导致整个页面挂载失败）
 * @param value
 * @returns {string}
 */
function safeDecode(value) {
  if (typeof value !== "string") {
    return "";
  }
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

/**
 * 解析 URL 的 query 参数
 * 每个参数值只解码一次（与浏览器行为一致），解码失败保留原值
 * @param href
 * @returns {object}
 */
function parseQueryParams(href) {
  var params = {};
  if (!href || typeof href !== "string") {
    return params;
  }
  var rest = href;
  var hashIdx = rest.indexOf("#");
  if (hashIdx >= 0) {
    rest = rest.slice(0, hashIdx);
  }
  var queryIdx = rest.indexOf("?");
  if (queryIdx < 0) {
    return params;
  }
  rest.slice(queryIdx + 1).split("&").forEach(function (pair) {
    if (!pair) {
      return;
    }
    var eq = pair.indexOf("=");
    var key = safeDecode(eq >= 0 ? pair.slice(0, eq) : pair);
    if (!key) {
      return;
    }
    params[key] = eq >= 0 ? safeDecode(pair.slice(eq + 1)) : "";
  });
  return params;
}

/**
 * 解析 query 字符串为对象（值只解码一次）
 * @param qs
 * @returns {object}
 */
function parseQueryString(qs) {
  var params = {};
  if (!qs || typeof qs !== "string") {
    return params;
  }
  qs.split("&").forEach(function (pair) {
    if (!pair) {
      return;
    }
    var eq = pair.indexOf("=");
    var key = safeDecode(eq >= 0 ? pair.slice(0, eq) : pair);
    if (!key) {
      return;
    }
    params[key] = eq >= 0 ? safeDecode(pair.slice(eq + 1)) : "";
  });
  return params;
}

/**
 * 严格解析 callback 地址
 * 只接受「scheme://host[:port]/path?query#hash」这种绝对地址，
 * 拒绝 userinfo（a@b 形式）、相对地址、协议相对地址以及任何 javascript:/data: 等伪协议
 * @param text 已经解码一次的 callback 文本
 * @returns {null|{scheme: string, hostname: string, port: string, path: string, query: object, hash: string}}
 */
function parseCallbackUrl(text) {
  if (!text || typeof text !== "string") {
    return null;
  }
  // scheme://authority（authority 不允许出现 @ / ? # 空白）path?query#hash
  // path 中同样不允许出现 @：否则 https://白名单域名@evil.com/ 会被解析成
  // host=白名单域名、path=@evil.com/，重建后浏览器仍会跳到 evil.com
  var matched = text.match(/^([A-Za-z][A-Za-z0-9+.\-]*):\/\/([^\/?#\s@]+)([^?#@]*)(\?[^#]*)?(#[\s\S]*)?$/);
  if (!matched) {
    return null;
  }
  var scheme = matched[1].toLowerCase();
  var authority = matched[2];
  var portMatched = authority.match(/^([^:]+)(?::(\d{1,5}))?$/);
  if (!portMatched) {
    return null;
  }
  var hostname = portMatched[1].toLowerCase();
  if (!/^[a-z0-9]([a-z0-9\-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9\-]*[a-z0-9])?)*$/.test(hostname)) {
    return null;
  }
  var port = "";
  if (portMatched[2]) {
    port = String(parseInt(portMatched[2], 10));
    if (!port || port < 1 || port > 65535) {
      return null;
    }
  }
  return {
    scheme: scheme,
    hostname: hostname,
    port: port,
    path: matched[3] || "",
    query: parseQueryString(matched[4] ? matched[4].slice(1) : ""),
    hash: matched[5] ? matched[5].slice(1) : ""
  };
}

/**
 * 校验 callback 跳转地址
 * 只有「协议在白名单内」且「主机精确匹配白名单」的地址才允许跳转，
 * 避免 javascript:、data: 等伪协议通过 host 校验后被当作脚本执行（DOM XSS）
 * @param callback 已经解码一次的 callback 文本
 * @returns {{ok: boolean, msg: string, params: object}}
 */
function checkCallback(callback) {
  if (!callback || typeof callback !== "string") {
    return { ok: false, msg: "callback 参数无效", params: null };
  }
  var params = parseCallbackUrl(callback);
  if (!params) {
    return { ok: false, msg: "callback 地址格式非法", params: null };
  }
  if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].callback_protocols.indexOf(params.scheme) === -1) {
    return { ok: false, msg: "callback \u534F\u8BAE\"" + params.scheme + "\"\u4E0D\u5728\u767D\u540D\u5355\u5185", params: null };
  }
  if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].callback_whitelist.indexOf(params.hostname) === -1) {
    return { ok: false, msg: "callback \u4E3B\u673A\"" + params.hostname + "\"\u4E0D\u5728\u767D\u540D\u5355\u5185", params: null };
  }
  return { ok: true, msg: "", params: params };
}

/**
 * 编码 path / hash 中的空白字符、控制字符与非 ASCII 字符
 * - path 与 hash 取自 callback 原文，本身已是 URL 编码形式（%20 等），
 *   若整体再编码一次会出现 %20 -> %2520 的重复编码，因此已有的合法 %XX 保持原样
 * - 孤立的 % （后面不是两位十六进制）编码为 %25，避免出现 100%%E6 这类歧义串
 * - 非 ASCII（中文、emoji 等）统一按 UTF-8 百分号编码，保证重建出的地址是纯 ASCII
 * @param text
 * @returns {string}
 */
function encodeUrlUnsafeChars(text) {
  var str = text || "";
  var out = "";
  for (var i = 0; i < str.length; i++) {
    var code = str.charCodeAt(i);
    if (code <= 32 || code === 127) {
      // 空白字符与控制字符
      var hex = code.toString(16).toUpperCase();
      out += "%" + (hex.length === 1 ? "0" + hex : hex);
    } else if (code === 37) {
      // '%'：仅当后面不是两位十六进制时才编码，已有 %XX 保持原样
      var isValidEscape = /^[0-9A-Fa-f]{2}$/.test(str.substr(i + 1, 2));
      out += isValidEscape ? '%' : '%25';
    } else if (code < 128) {
      out += str.charAt(i);
    } else {
      var next = i + 1 < str.length ? str.charCodeAt(i + 1) : 0;
      if (code >= 0xD800 && code <= 0xDBFF && next >= 0xDC00 && next <= 0xDFFF) {
        // 代理对（emoji 等）：整体编码，避免对半个代理对调用 encodeURIComponent 抛 URIError
        out += encodeURIComponent(str.substr(i, 2));
        i++;
      } else {
        try {
          out += encodeURIComponent(str.charAt(i));
        } catch (e) {
          var _hex = code.toString(16).toUpperCase();
          out += "%" + (_hex.length === 1 ? "0" + _hex : _hex);
        }
      }
    }
  }
  return out;
}

/**
 * 安全的 encodeURIComponent
 * 未配对的代理对等非法字符会让 encodeURIComponent 抛 URIError，
 * 这里逐字符降级编码，保证不会因为一个畸形参数导致整页挂载失败
 * @param value
 * @returns {string}
 */
function safeEncodeURIComponent(value) {
  var str = value == null ? "" : String(value);
  try {
    return encodeURIComponent(str);
  } catch (e) {
    var out = "";
    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);
      if (code >= 0xD800 && code <= 0xDBFF) {
        var next = i + 1 < str.length ? str.charCodeAt(i + 1) : 0;
        if (next >= 0xDC00 && next <= 0xDFFF) {
          out += encodeURIComponent(str.substr(i, 2));
          i++;
        } else {
          out += "%" + code.toString(16).toUpperCase();
        }
      } else if (code >= 0xDC00 && code <= 0xDFFF) {
        out += "%" + code.toString(16).toUpperCase();
      } else {
        out += encodeURIComponent(str.charAt(i));
      }
    }
    return out;
  }
}

/**
 * 生成 query 字符串，键值均做编码
 * @param query
 * @returns {string}
 */
function buildQueryString(query) {
  var str = "";
  for (var key in query) {
    if (!Object.prototype.hasOwnProperty.call(query, key)) {
      continue;
    }
    var value = query[key];
    str += "&" + safeEncodeURIComponent(key) + (value ? "=" + safeEncodeURIComponent(value) : "");
  }
  return str.substr(1);
}

/**
 * 依据校验通过的 callback 组件重建跳转地址
 * 所有路径、query、hash 都会重新编码，保证重建结果与校验结果一致
 * @param params checkCallback 返回的 params
 * @param extra 需要追加的 query 参数（如 openid、t）
 * @returns {string}
 */
function buildCallbackUrl(params, extra) {
  if (!params) {
    return "";
  }
  var target = params.scheme + "://" + params.hostname;
  if (params.port) {
    target += ":" + params.port;
  }
  target += encodeUrlUnsafeChars(params.path);
  var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, params.query, extra || {});
  var qs = buildQueryString(query);
  if (qs) {
    target += "?" + qs;
  }
  if (params.hash) {
    target += "#" + encodeUrlUnsafeChars(params.hash);
  }
  return target;
}

/**
 * 校验最终要跳转的地址是否安全（协议 + 主机双重校验，作为跳转前的最后一道防线）
 * @param target
 * @returns {boolean}
 */
function isSafeRedirect(target) {
  if (!target || typeof target !== "string") {
    return false;
  }
  var res = checkCallback(target);
  return res.ok;
}

/**
 * 生成query字符串
 * @param query
 * @returns {string}
 */
function queryBuilder(query) {
  if ((typeof query === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(query)) !== 'object') {
    return '';
  }
  var queryStr = '';
  for (var key in query) {
    queryStr += "&" + key + "=" + encodeURIComponent(query[key]);
  }
  return queryStr.substr(1);
}

/***/ }),

/***/ "KOTK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"1em"},attrs:{"id":"app"}},[(_vm.errorMsg)?_c('div',{staticClass:"error-tip"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3a91d54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("KOTK");
function injectStyle (ssrContext) {
  __webpack_require__("1blB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3a91d54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Log) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_load_js__ = __webpack_require__("5mn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_load_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_load_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_load_js___default()([{
  url: 'https://openmonitor.alipay-eco.com/cloudadmin/alipayLogger.js',
  async: true
}]).then(function () {
  Log('loadJS ok', __bl);
  init();
}).catch(function () {
  Log('loadJS Error');
  init();
});

function init() {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lotU")))

/***/ }),

/***/ "rvz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  key_prefix: "dev_oauth2_",
  password: "aAr9MVS9j1",
  api_url: {
    "localhost": "//nethos.diandianys.com/api/app",
    "nethosweb.diandianys.com": "//nethos.diandianys.com/api/app",
    "test-zheer-wx.hztywl.cn": "//nethos.diandianys.com/api/app",
    "pat-test.gjwlyy.com": "//api-test.gjwlyy.com/api/app",
    "www.gjwlyy.com": "http://api.teyangsoft.com/?service=gjwlyy&action=index&sign=1ea3f0c0dd0c91ee54e546a99beafbfb"
  },
  appid: {
    "localhost": "wxa49f90b4ff678ef2",
    "nethosweb.diandianys.com": "wxa49f90b4ff678ef2",
    "test-zheer-wx.hztywl.cn": "wxa49f90b4ff678ef2",
    "pat-test.gjwlyy.com": "wx3d274480f31f6de2",
    "www.gjwlyy.com": "wx3d274480f31f6de2"
  },
  alipay_appid: {
    "nethos-webtest.diandianys.com": "2016021701147425",
    "www.gjwlyy.com": "2014102300014454"
  },
  alipay_oauth2: {
    "nethos-webtest.diandianys.com": "http://nethosapi.diandianys.com",
    "www.gjwlyy.com": "https://api.gjwlyy.com"
  },
  //callback 参数允许跳转的协议白名单（防止 javascript:、data: 等协议绕过域名白名单）
  callback_protocols: ["http", "https"],
  //callback 参数允许跳转的白名单 host
  callback_whitelist: ["wx.hztywl.cn", "wechat-hljk.huiliaoyiyuan.com", "pat.xczsgsyy.com", "wechat.xcrmyy.cn", "wechat.dhqzxyy.com", "fhct-wechat.fhctdyf.com", "saas.diandianys.com", "wechat.gnxdyrmyy.com", "wechat.sbnk.cn", "wechat.xhhos.com", "wechat.ahnmc.com", "test-wx.diandianys.com", "szkf-wechat.diandianys.com"],
  base_params: {
    channel: "4",
    format: "JSON",
    oper: "127.0.0.1",
    spid: "1001"
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Log) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_util__ = __webpack_require__("CPGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_config__ = __webpack_require__("rvz5");

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      brower: '',
      page: "",
      hrefParams: {},
      query: {},
      cookies: "",
      cookie: '',
      errorMsg: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    Log('浏览器信息', window.navigator.userAgent, __bl);
    __bl && __bl._lg && __bl._lg('pv', {
      page: location.href
    });
    __bl && __bl.api && __bl.api('浏览器信息', true, 200, 200, window.navigator.userAgent);
    //微信打开
    //query 自行解析（只解码一次、非法百分号编码不会抛异常），避免 js-url 解析异常导致页面挂载失败
    var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["a" /* parseQueryParams */])(location.href);
    this.hrefParams = { query: query };
    this.query = query;
    this.cookie = document.cookie;
    __bl && __bl.api && __bl.api('cookie信息', true, 200, 200, this.cookie);
    __bl && __bl.api && __bl.api('get信息', true, 200, 200, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.query));

    //校验必传参数 appid、plat、callback 是否缺失
    var requiredKeys = ['appid', 'plat', 'callback'];
    var missingKeys = requiredKeys.filter(function (key) {
      return !_this.query[key];
    });
    if (missingKeys.length) {
      var msg = '\u7F3A\u5C11' + missingKeys.join('、') + '\u53C2\u6570';
      __bl && __bl.api && __bl.api('参数缺失', false, 400, 400, msg);
      this.errorMsg = msg;
      return;
    }

    //校验 callback 跳转目标是否在白名单内（协议 + 主机）
    var cbRes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["b" /* checkCallback */])(this.query.callback);
    if (!cbRes.ok) {
      __bl && __bl.api && __bl.api('callback白名单校验失败', false, 400, 400, cbRes.msg);
      this.errorMsg = cbRes.msg;
      return;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* isBrower */])("micromessenger")) {
      this.brower = 'weixin';
      this.weixinInit();
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["c" /* isBrower */])('alipayclient')) {
      this.brower = 'alipay';
      this.alipayInit();
    } else {
      //非微信支付宝打开
    }
  },

  methods: {
    //解析并校验 callback，不合法时提示并返回 null
    getCallbackParams: function getCallbackParams(p) {
      var callback = p && p.callback;
      var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["b" /* checkCallback */])(callback);
      if (!res.ok) {
        __bl && __bl.api && __bl.api('callback白名单校验失败', false, 400, 400, res.msg);
        this.errorMsg = res.msg;
        return null;
      }
      return res.params;
    },


    //跳转前的最后一道防线：协议 + 主机再校验一次
    doRedirect: function doRedirect(url) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["d" /* isSafeRedirect */])(url)) {
        var msg = '\u91CD\u5B9A\u5411\u5730\u5740"' + url + '"\u4E0D\u5728\u767D\u540D\u5355\u5185';
        __bl && __bl.api && __bl.api('重定向地址白名单校验失败', false, 400, 400, msg);
        this.errorMsg = msg;
        return;
      }
      console.log('重定向地址', url);
      location.href = url;
    },
    alipayInit: function alipayInit() {
      var query = this.query;
      if (!query || !query.callback) {
        alert("get参数不能为空");
        return;
      }
      var APPID = __WEBPACK_IMPORTED_MODULE_2__lib_config__["a" /* default */].alipay_appid[location.hostname];
      var cookie = this.$cookies.get('alipayuserid_' + APPID);
      if (cookie) {
        cookie = cookie.split('_');
        var cbParams = this.getCallbackParams(query);
        if (!cbParams) {
          return;
        }
        var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* buildCallbackUrl */])(cbParams, { openid: cookie[0], next: cookie[1] || '', t: new Date().getTime() });
        this.clearCookies();
        this.doRedirect(red);
      } else {
        this.goOauth2();
      }
    },
    weixinInit: function weixinInit() {
      var query = this.query;
      if (!query || !query.callback) {
        alert("get参数不能为空");
        return;
      }

      var openid = this.$cookies.get('openid_' + query.appid);
      if (query.openid) {
        this.gotOpenid(query, query.openid);
      } else if (openid) {
        this.gotOpenid(query, openid);
      } else {
        this.goOauth2(query);
      }
    },
    gotOpenid: function gotOpenid(p, openid) {
      console.log('cb', p.callback);
      var cbParams = this.getCallbackParams(p);
      if (!cbParams) {
        return;
      }
      //this.clearCookies();
      var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* buildCallbackUrl */])(cbParams, { openid: openid, t: new Date().getTime() });
      this.doRedirect(red);
    },


    //http://test-wechat-repeater.hztywl.cn/wechat/plat/oauth/wxa49f90b4ff678ef2?url=https%3a%2f%2fwww.baidu.com&scope=snsapi_userinfo
    goOauth2: function goOauth2(p) {
      var _location = location,
          hostname = _location.hostname;

      var APPID = __WEBPACK_IMPORTED_MODULE_2__lib_config__["a" /* default */].alipay_appid[location.hostname];
      if (this.brower === 'weixin') {
        location.replace('http://' + (p.plat && p.plat === 'pro' ? "" : "test-") + 'wechat-repeater.diandianys.com/wechat/plat/oauth/' + p.appid + '?url=' + encodeURIComponent(location.href) + '&scope=snsapi_base'); //snsapi_base/snsapi_userinfo
      } else if (this.brower === 'alipay') {
        location.replace(__WEBPACK_IMPORTED_MODULE_2__lib_config__["a" /* default */].alipay_oauth2[hostname] + '/alipay/oauth/' + APPID + '?scope=auth_user&url=' + encodeURIComponent(location.href));
      }
    },
    goBack: function goBack(p) {
      var showRed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var openid = this.$cookies.get('openid_' + p.appid);
      var cbParams = this.getCallbackParams(p);
      if (!cbParams) {
        return;
      }
      this.clearCookies();
      var red = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_util__["e" /* buildCallbackUrl */])(cbParams, { openid: openid, t: new Date().getTime() });
      if (showRed) alert(red);
      this.doRedirect(red);
    },
    clearCookies: function clearCookies() {
      var _this2 = this;

      this.$cookies.keys().forEach(function (res) {
        console.log(res, _this2.$cookies.remove(res, '/', '.hztywl.cn'));
      });
    }
  },
  watch: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lotU")))

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7485e8eddac6f4d413ee.js